import React from 'react';
import { SearchResult } from '../config/constants';

interface SearchOverlayProps {
    showSearchOverlay: boolean;
    searchTerm: string;
    setSearchTerm: (term: string) => void;
    searchResults: SearchResult[];
    handleSearchResultClick: (result: SearchResult) => void;
    onClose: () => void;
    searchOverlayRef: React.RefObject<HTMLDivElement | null>;
}

const SearchOverlay: React.FC<SearchOverlayProps> = ({
    showSearchOverlay,
    searchTerm,
    setSearchTerm,
    searchResults,
    handleSearchResultClick,
    onClose,
    searchOverlayRef
}) => {
    // No need to check showSearchOverlay here, App.tsx will conditionally render this component
    return (
        <div className="search-overlay" ref={searchOverlayRef}>
            <div className="search-overlay-header">
                <input
                    type="text"
                    placeholder="Search Bible..."
                    value={searchTerm}
                    onChange={(e) => setSearchTerm(e.target.value)}
                    autoFocus
                />
                <button onClick={onClose} className="close-search-button">Close</button>
            </div>
            <div className="search-results-list">
                {searchResults.length > 0 ? (
                    searchResults.map((result, index) => (
                        <div key={index} className="search-result-item" onClick={() => handleSearchResultClick(result)}>
                            <strong>{result.book} {result.chapter}:{result.verse}</strong>
                            <p>{result.text}</p>
                        </div>
                    ))
                ) : (
                    searchTerm.trim() && <div>No results found.</div>
                )}
            </div>
        </div>
    );
};

export default SearchOverlay;
